/**
 * dmlWhereScope — how far an UPDATE / DELETE reaches, read off its clause
 * outline (`extractUpdateOutline` / `extractDeleteOutline`, which already
 * normalise every engine's DML shape into `whereStart` / `hasJoinTail` /
 * `limitStart`):
 *   - `'filtered'`     — it has a WHERE.
 *   - `'all-rows'`     — no WHERE: every row of the target changes.
 *   - `'join-matched'` — no WHERE, but a JOIN / USING / FROM list (MySQL
 *     `UPDATE … JOIN`, `DELETE t1 FROM t1 JOIN t2 …`, PG `DELETE … USING a, b`)
 *     bounds it to the rows that list matches (I8).
 *   - `'limited'`      — no WHERE, but MySQL's single-table `… LIMIT n` caps
 *     how many rows it touches (I7).
 *
 * The one no-WHERE detector behind the red "No WHERE" badge and the empty
 * WHERE row, on the Visual view and the compact popover alike.
 */
export type DmlWhereScope = 'filtered' | 'all-rows' | 'join-matched' | 'limited';

export function dmlWhereScope(outline: {
  readonly whereStart: number | null;
  readonly hasJoinTail: boolean;
  readonly limitStart: number | null;
}): DmlWhereScope {
  if (outline.whereStart !== null) return 'filtered';
  if (outline.hasJoinTail) return 'join-matched';
  return outline.limitStart !== null ? 'limited' : 'all-rows';
}
